module.exports = __webpack_public_path__ + "img/点击旋转.0682d2a1.png";